import { motion } from "framer-motion";

const STEPS = [
  { n: "01", t: "Conversation & Assessment", d: "We start by understanding your story — your health, injuries, exercise history, goals and what you want to be able to do." },
  { n: "02", t: "Understand How You Move", d: "We look at how you move, your mobility and your strength — and identify where you are starting from." },
  { n: "03", t: "Your PLST Program", d: "We build a strength program around your body, your goals and where you are today — with a clear plan for where you want to go." },
  { n: "04", t: "Train With Guidance", d: "Your physiotherapist guides your training, helping you choose the right exercises, loads and progressions as you get stronger." },
  { n: "05", t: "Review & Progress", d: "We review your progress and adjust your program as you get stronger, more capable and more confident." },
];

const IMG = "/media/conversation-assessment.webp";

export default function Process() {
  return (
    <section id="process" className="py-24 lg:py-40" data-testid="process-section">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <div className="text-xs uppercase tracking-[0.28em] text-[#8A8A8A]">
                <span className="w-8 h-px bg-[#A67C00] inline-block align-middle mr-3" />
                The PLST Process
              </div>
              <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#1E1E1E] leading-[0.95]">
                It starts with a <br />
                <span className="italic font-medium text-[#A67C00]">conversation.</span>
              </h2>
              <p className="mt-6 text-[#1E1E1E]/70 leading-relaxed max-w-md">
                No two people follow the same program. Every journey at PLST starts with a conversation, an assessment, and a plan built around you.
              </p>

              <div className="mt-10 relative overflow-hidden border border-[#1E1E1E]/10 img-zoom">
                <img src={IMG} alt="Physiotherapist assessment" className="w-full h-[380px] lg:h-[520px] object-cover" />
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 space-y-6">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-8% 0px" }}
                transition={{ duration: 0.7, delay: i * 0.05 }}
                className="group grid grid-cols-12 gap-4 items-start border border-[#1E1E1E]/10 hover:border-[#A67C00] transition-colors bg-white p-7 lg:p-10"
                data-testid={`process-step-${s.n}`}
              >
                <div className="col-span-3 md:col-span-2">
                  <div className="italic font-medium text-4xl md:text-5xl text-[#A67C00]">{s.n}</div>
                </div>
                <div className="col-span-9 md:col-span-10">
                  <h3 className="font-display text-xl md:text-2xl tracking-tight text-[#1E1E1E]">{s.t}</h3>
                  <p className="mt-3 text-[#1E1E1E]/70 leading-relaxed">{s.d}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
